import { handleCopyText } from "../../Utils";
import { MainContext } from "../../Context";
import React, { useContext } from "react";

const BankCard = () => {
  const { setting } = useContext(MainContext);

  // ====================================================================================

  return (
    <div className="app">
      <aside className="card-front">
        <span
          onClick={() => handleCopyText(setting.cart_number)}
          className="number"
        >
          {setting.cart_number}
        </span>
        <span
          onClick={() => handleCopyText(setting.cart_sheba)}
          className="number2"
        >
          {setting.cart_sheba}
        </span>
        <span className="name">
          {setting.owner_cart}
        </span>
        <span
          onClick={() => handleCopyText(setting.account_number)}
          className="expiry"
        >
          {setting.account_number}
        </span>

        <div className="chip">
          <svg role="img" viewBox="0 0 100 100" aria-label="Chip">
            <use href="#chip-lines" />
          </svg>
        </div>
      </aside>

      <svg id="chip">
        <g id="chip-lines">
          <polyline points="0,50 35,50"></polyline>
          <polyline points="0,20 20,20 35,35"></polyline>
          <polyline points="50,0 50,35"></polyline>
          <polyline points="65,35 80,20 100,20"></polyline>
          <polyline points="100,50 65,50"></polyline>
          <polyline points="35,35 65,35 65,65 35,65 35,35"></polyline>
          <polyline points="0,80 20,80 35,65"></polyline>
          <polyline points="50,100 50,65"></polyline>
          <polyline points="65,65 80,80 100,80"></polyline>
        </g>
      </svg>

      <svg id="contactless">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9.172 15.172a4 4 0 0 1 5.656 0"></path>
        <path d="M6.343 12.343a8 8 0 0 1 11.314 0"></path>
        <path d="M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"></path>
      </svg>
    </div>
  );
};

export default BankCard;
